<template>
  <div
    class="setting-ocpc-form"
  >
    <div
      v-if="!datasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>

    <a-form
      v-else
      :form="form"
      :class="{'en-form': isEnglish}"
      @submit.prevent="saveForm"
    >
      <a-form-item>
        <template slot="label">
          {{ $t('message["1877"]') }}
        </template>
        <a-switch
          v-decorator="['switch', { valuePropName: 'checked', initialValue: status === 1 }]"
          @change="firstSwitch"
        />
        <span class="switch-txt">{{ setSwitchTxt(status) }}</span>
        <div
          class="open-stop-tips"
        >
          {{ tipsTxt }}
          <template>
            {{ viewDocument[0] }}<a
              href="https://help.westartrack.com/article/d_5db660ce4db67f79e11104d8.html"
              target="_blank"
            >{{ viewDocument[1] }}</a>{{ viewDocument[2] }}
          </template>
        </div>
      </a-form-item>
      <div class="ocpc-set-module">
        <h3 class="ocpc-set-tit">
          {{ $t('message["1848"]') }}
        </h3>
        <a-form-item
          v-if="queryArgs.type* 1 === 1"
          label="Token"
        >
          <a-input
            v-decorator="[
              'token',
              {
                initialValue: datas.token
              },
            ]"
            :placeholder="tokenPlace"
            @change="changeTokenVal"
          />
        </a-form-item>
        <template v-else-if="queryArgs.type*1 === 3">
          <a-form-item>
            <template slot="label">
              {{ $t('message["1852"]') }}
            </template>
            <template v-if="!datas.isBind">
              {{ $t('message["1853"]') }}
              <a
                href="javascript:;"
                class="ml-16"
                @click="authorizeHandle"
              > {{ $t('message["1854"]') }}</a>
            </template>
            <template v-else>
              {{ $t('message["1858"]') }}
            </template>
          </a-form-item>
          <a-form-item>
            <template slot="label">
              {{ $t('message["1856"]') }}
            </template>
            <a-input
              v-decorator="[
                'counter',
                {
                  rules: [
                    { required: true, message: positonNumPlace },
                  ],
                  initialValue: datas.token && datas.token.counter
                },
              ]"
              type="text"
              :maxlength="8"
              :placeholder="positonNumPlace"
              @change="changeTokenValCounter"
            />
          </a-form-item>
          <a-form-item>
            <template slot="label">
              {{ $t('message["1867"]') }}
            </template>
            <a-input
              v-decorator="[
                'target',
                {
                  rules: [
                    { required: true, message: idTypePlace },
                  ],
                  initialValue: datas.token && datas.token.target
                },
              ]"
              type="text"
              :placeholder="idTypePlace"
              @change="changeTokenValTarget"
            />
          </a-form-item>
        </template>
        <template v-else>
          <a-form-item>
            <template slot="label">
              {{ $t('message["1868"]') }}
            </template>
            <a-input
              v-decorator="[
                'token',
                {
                  initialValue: datas.token
                },
              ]"
              :placeholder="transformTxt"
              @change="changeTranferVal"
            />
          </a-form-item>
          <a-form-item v-if="datas['google_push_url']">
            <template slot="label">
              {{ $t('message["1870"]') }}
            </template>
            <a-input
              v-decorator="[
                'token2',
                {
                  initialValue: datas['google_push_url']
                },
              ]"
              :disabled="true"
            />
            <a
              id="copyBtn"
              class="ml-16"
              href="javascript:;"
              @click="doCopy"
            >
              {{ $t('message["318"]') }}
            </a>
          </a-form-item>
        </template>
      </div>
      <div
        v-if="configData.length > 0"
        class="ocpc-set-module"
      >
        <h3 class="ocpc-set-tit">
          {{ $t('message["1874"]') }}
        </h3>
        <a-form-item>
          <template slot="label">
            {{ $t('message["1872"]') }}
          </template>
          <a-radio-group
            v-decorator="['status', { initialValue: datas.config && datas.config.status}]"
            @change="setChange"
          >
            <a-radio :value="0">
              {{ $t('message["904"]') }}
            </a-radio>
            <a-radio :value="1">
              {{ $t('message["1873"]') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-for="item in configData"
          :key="item.id"
        >
          <template slot="label">
            {{ item.fieldname }}
          </template>
          <a-checkbox-group
            v-if="item.options.length > 0"
            v-decorator="[item.fieldkey, { initialValue: datas.config[item.fieldkey] }]"
            @change="checkboxHandle(item,$event)"
          >
            <a-checkbox
              v-for="item2 in item.options"
              :key="item2.id"
              :value="item2.id + ''"
            >
              {{ item2.name }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-item>
      </div>
      <div
        ref="footerBtn"
        class="footer-wrap"
      >
        <div
          ref="footer"
          class="footer"
          :class="{'ani':isShowBtn}"
        >
          <a-button
            type="primary"
            html-type="submit"
            :loading="submitting"
          >
            {{ $t('message["21"]') }}
          </a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  data () {
    return {
      form: this.$form.createForm(this),
      isShowBtn: false,
      counter: 1,
      // stopTips: ['尚未开启百度推送，点击右侧“开启”进行推送，点击查看', '尚未开启Google推送，点击右侧“开启”进行推送，点击查看', '已停用，停止给yandex推送消息'], // 停用提示语
      onTips: [this.$t('message["1845"]'), this.$t('message["1846"]'), this.$t('message["1847"]')], // 未设置授权时的提示语
      status: this.datasReady ? this.datas.status : 1
    }
  },
  computed: {
    ...mapState('config/ocpc', ['datas', 'datasReady', 'config', 'submitting', 'channelType']),
    isEnglish () {
      return this.getLang() === 'en'
    },
    // tips
    tipsTxt () {
      const { type } = this.datas
      const stopTips = this.$t('message["1844"]').split('|')
      // const msg = this.isToken ? this.$t('message["1466"]') : this.onTips[type - 1]
      return this.status === 2 ? stopTips[0] + this.channelType[type - 1] + stopTips[1] : this.onTips[type - 1]
    },
    idTypePlace () {
      return this.$t('message["1866"]')
    },
    positonNumPlace () {
      return this.$t('message["1875"]')
    },
    queryArgs () {
      return this.$route.query
    },
    tokenPlace () {
      return this.$t('message["1849"]')
    },
    transformTxt () {
      return this.$t('message["1869"]')
    },
    viewDocument () {
      return this.$t('message["1859"]').split('|')
    },
    configData () {
      const { config } = this
      let arr = []
      for (let key in config) {
        const values = config[key]
        if (key === 'info_level' || key === 'info_status' || key === 'info_type') {
          if (key === 'info_level') {
            if (values.fieldconfig.type === 2) {
              values.options.forEach((item, index) => {
                const starsArr = this.$t('message["1444"]').split(',')
                item.name = starsArr[values.options.length - index - 1]
              })
            }
            values.options.reverse()
          }
          arr.push(config[key])
        }
      }
      return arr
    }
  },
  watch: {
    datasReady (val) {
      if (val) {
        this.setFooterStyle()
        this.status = this.datas.status
      }
    },
    datas: {
      handler (val) {
        this.counter++
        if (val && this.counter > 2) {
          this.isShowBtn = true
          this.setFooterStyle()
          // this.$refs.footerBtn.style.height = '64px'
        }
      },
      deep: true
    }
  },
  async mounted () {
    await this.fetchSetDatas({ type: this.queryArgs.type })
    if (this.datasReady) {
      const { projectname = '', comname = '' } = this.$store.state.baseinfo
      document.title = 'oCPC' + `- ${projectname} - ${comname}`
      // this.status = this.datas.status
    }
  },
  created () {
    this.setFooterStyle()
    window.addEventListener('resize', this.setFooterStyle)
    document.addEventListener('scroll', this.setFooterStyle)
  },
  methods: {
    ...mapActions('config/ocpc', ['fetchSetDatas', 'openCloseOcpc', 'setOcpc']),
    getLang,
    async saveForm () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.datas.status = this.status
          const chain = await this.setOcpc()
          chain.params(this.datas)
            .onSuccess(async () => {
              this.$router.push({ name: 'setList' })
            })
            .fetch()
        }
      })
    },
    async firstSwitch (e) {
      this.status = e ? 1 : 2
      await this.openCloseOcpc({ type: this.queryArgs.type, isOpen: e })
    },
    setSwitchTxt (b) {
      const a = this.status === 1 ? this.$t('message["1466"]') : this.$t('message["1474"]')
      return a
    },
    setChange (val) {
      this.datas.config.status = val.target.value
    },
    changeTokenVal (e) {
      this.datas.token = e.target.value
    },
    setFooterStyle () {
      this.$nextTick(() => {
        if (!this.$refs.footer) return

        const $footer = this.$refs.footer

        $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
        // console.log(getScrollTop(), $footer.parentNode, $footer.parentNode.offsetTop)
        const sectionWidth = this.$getSectionWidth()
        const pageWidth = this.$getPageSize().pageWidth
        // console.log(sectionWidth, pageWidth, $footer.parentNode.offsetLeft)
        if ($footer.parentNode.offsetTop - this.$getScrollTop() - window.innerHeight + $footer.parentNode.offsetHeight + 44 < 0) {
          $footer.style.position = 'relative'
          $footer.style.left = 0
          $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
        } else {
          $footer.style.position = 'fixed'
          $footer.style.left = pageWidth <= sectionWidth ? 200 + 1 + 'px' : 200 + (pageWidth - sectionWidth) / 2 + 1 + 'px'
        }
      })
    },
    async authorizeHandle () {
      const formDatas = { ...this.datas, status: this.status }
      const chain = await this.setOcpc()
      chain.params(formDatas)
        .onSuccess(raw => {
          location.href = raw.redirect_uri
        })
        .config({ tip: false })
        .fetch()
    },
    checkboxHandle (item, e) {
      this.datas.config[item.fieldkey] = e
    },
    changeTranferVal (e) {
      this.datas.token = e.target.value
    },
    changeTokenValCounter (e) {
      this.datas.token.counter = e.target.value
    },
    changeTokenValTarget (e) {
      this.datas.token.target = e.target.value
    },
    doCopy () {
      const that = this
      this.$copyText(this.datas['google_push_url']).then(function (e) {
        that.$message.success(that.$t('message["321"]'))
      }, function (e) {
        that.$message.error(that.$t('message["324"]'))
      })
    }
  }
}
</script>
<style lang="scss" scoped >
.setting-ocpc-form::v-deep {
  padding: 24px 0 0;
  line-height: 32px;
  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .ant-row {
    padding-left: 100px;
    .ant-form-item-label {
      float: left;
      width: 80px;
      margin-left: -100px;
      label {
      color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
    }
    .switch-txt {
      margin-left: 12px;
    }
  }
  .footer-wrap {
    height: 64px;
    margin-top: 40px;
    position: relative;
  }
  .footer {
    position: fixed;
    bottom: -89px;
    left: 0;
    z-index: 999;
    height: 64px;
    margin-left: -40px;
    padding: 16px 120px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    transition: bottom 0.5s linear;
     .ant-btn {
        margin-right: 0 ;
      }
    span.sub-tip {
      color: #b3b3b3;
      margin-left: 10px;
    }
     opacity: 0;
    // transform: translateY(100%)
  }
  .ani {
    bottom: 0;
    opacity: 1;
  }
  .open-stop-tips {
    font-size: 12px;
    color: #999;
  }
.ocpc-set-module {
  .ocpc-set-tit {
    height: 24px;
    line-height: 24px;
    font-weight: 500;
    margin-bottom: 10px;
  }
}
}
.en-form::v-deep {
  .ant-row {
    padding-left: 170px;
    .ant-form-item-label {
      float: left;
      width: 160px;
      margin-left: -170px;
      label {
      color: #666;
      }
    }
    .first-class-time {
      margin-left: 0 !important;
      li strong {
        width: 80px !important;
      }
    }
  }
}
</style>
